/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { getCsvPacksModel, uploadPacks } from '../app/store/actions/packs';
import UploadFilesComponent from '../components/upload';
import PacksImportErrors from '../components/upload/PacksImportErrors';
import PacksImportResults from '../components/upload/PacksImportResults';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';

class UploadPacksPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorKey: null,
      errorParams: {},
      errors: [],
      results: [],
      successMessage: null,
    };
  }

  sendFile = async (file) => {
    await this.setState({
      errorKey: null, errorParams: {}, errors: [], results: [], successMessage: null,
    });
    const result = await this.props.uploadPacks(file);

    if (!result) return;

    if (result.errors && result.errors.length) {
      await this.setState({
        errorKey: result.messageKey || null,
        errorParams: result.messageParams || {},
        errors: result.errors,
        results: [],
        successMessage: null,
      });
    } else if (result.results && result.results.length) {
      await this.setState({
        errorKey: null,
        errorParams: {},
        errors: [],
        results: result.results,
        successMessage: null,
      });
    } else if (result.success === false) {
      await this.setState({
        errorKey: result.messageKey || null,
        errorParams: result.messageParams || {},
        errors: [],
        results: [],
        successMessage: null,
      });
    } else if (result.success === true) {
      await this.setState({
        errorKey: null, errorParams: {}, errors: [], results: [], successMessage: true,
      });
    }
  }

  modelDownload = async () => {
    await this.props.getCsvPacksModel();
  }

  goBack = () => {
    history.push(ROUTES.PACKS);
  }

  render() {
    const {
      errorKey, errorParams, errors, results, successMessage,
    } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importsPacks" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importPacksText1" /></strong></p>
            <p><strong><Translate value="importPacksText2" /></strong></p>
            <p><strong><Translate value="importPacksText3" /></strong></p>
            <p><strong><Translate value="importPacksText13" /></strong></p>
            <br />
            <p><Translate value="importPacksText4" /></p>
            <p><Translate value="importPacksText5" /></p>
            <p><Translate value="importPacksText6" /></p>
            <p><Translate value="importPacksText10" /></p>
            <p><Translate value="importPacksText7" /></p>
            <p><Translate value="importPacksText8" /></p>
            <p><Translate value="importPacksText9" /></p>
            <p><Translate value="importPacksText11" /></p>
            <p><Translate value="importPacksText12" /></p>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={(
              <React.Fragment>
                <PacksImportErrors
                  errorKey={errorKey}
                  errorParams={errorParams}
                  errors={errors}
                />
                <PacksImportResults results={results} />
              </React.Fragment>
            )}
          />

          {successMessage && (
            <p style={{ color: 'green', marginTop: '1rem' }}>
              <strong><Translate value="packCreated" /></strong>
            </p>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadPacks: file => dispatch(uploadPacks(file)),
  getCsvPacksModel: () => dispatch(getCsvPacksModel()),
});

export default connect(null, mapDispatchToProps)(UploadPacksPage);
